<template>
  <div class="is-flex is-flex-direction-column is-gap-4">
    <CollapseView
      v-for="item in faqItems"
      :key="item.key"
      class="has-background-light has-border-radius"
      :open="item.open"
      @open="onOpen(item)"
      @close="onClose(item)"
    >
      <template #trigger="{ open: isItemOpen }">
        <div
          class="is-flex is-justify-content-space-between is-align-items-center is-gap-2 is-full-width p-3"
        >
          <span class="has-text-weight-semibold">
            {{ item.question() }}
          </span>
          <i
            class="cls has-text-primary"
            :class="`cls-${isItemOpen ? Icon.MINUS : Icon.ADD}`"
            aria-hidden="true"
          />
        </div>
      </template>
      <div class="px-3 pb-3" v-dompurify-html="item.answer(price)" />
    </CollapseView>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import CollapseView from '@/modules/core/ui/components/wrappers/CollapseView.vue';
import { Icon } from '@/modules/core/app/enums/Icon';
import { FinancialAdvisorFaqItem } from '@/modules/financialadvisor/constants/FinancialAdvisorFaqItem';
import { HasAuthUserMixin } from '@/modules/core/app/mixins/HasAuthUserMixin';
import { AdvisorUpgradePageFaqExpanded } from '@/modules/financialadvisor/models/segmentevents/AdvisorUpgradePageFaqExpanded';

export default defineComponent({
  name: 'FinancialAdvisorProFaqAccordion',
  emits: [],
  mixins: [HasAuthUserMixin],
  components: {
    CollapseView
  },
  props: {
    price: {
      type: String as PropType<string>,
      required: true
    }
  },
  static: {
    Icon
  },
  data(): {
    faqItems: FinancialAdvisorFaqItem[];
  } {
    return {
      faqItems: FinancialAdvisorFaqItem.getValues().map(
        (item: FinancialAdvisorFaqItem): FinancialAdvisorFaqItem => ({
          ...item,
          open: false
        })
      )
    };
  },
  methods: {
    onOpen(item: FinancialAdvisorFaqItem): void {
      item.open = true;

      AdvisorUpgradePageFaqExpanded.dispatch(item.key, this.authUser);
    },
    onClose(item: FinancialAdvisorFaqItem): void {
      item.open = false;
    }
  }
});
</script>
